import React from "react";
import { DataTable } from "@sscs/ui";
import { estimateTableHeight } from "../../../utils";
const ComponentListTable = ({ matchCount, totalCount, queryStatus, rowIndex, itemId, columns, title, children, empty = { subject: "components" }, initialItemCount, pagination, onPaginationChange, }) => {
    return (React.createElement(DataTable, { columns: columns, title: title, empty: empty, status: queryStatus, pagination: {
            id: `${itemId}-list-pagination-${rowIndex}`,
            itemCount: matchCount,
            pagination,
            onChange: onPaginationChange,
            initialItemCount,
        }, style: queryStatus.status !== "SUCCESS"
            ? { minHeight: estimateTableHeight(totalCount) }
            : {} }, children));
};
export default ComponentListTable;
//# sourceMappingURL=Table.js.map